import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getLectureStudents } from "../../../../services/dashboard/apiLecture";

export const useGetLectureStudents = ({ params = {}, courseId, lectureId }) => {
    const queryClient = useQueryClient();
    const {
        isPending,
        data: lectureStudents,
        isSuccess,
    } = useQuery({
        queryKey: ["lectureStudentsDashboard", ...Object.values(params), courseId, lectureId],
        queryFn: () => getLectureStudents({ filterObject: params, courseId, lectureId })
    });


    const totalPages = Math.ceil(
        lectureStudents?.meta?.total / lectureStudents?.meta?.per_page
    );

    // PRE-FETCHING
    if (isSuccess && params.page < totalPages) {
        queryClient.prefetchQuery({
            queryKey: ["lecturesDashboard", ...Object.values(params), courseId, lectureId],
            queryFn: () => { }
        });
    }

    if (isSuccess && params.page > 1) {
        queryClient.prefetchQuery({
            queryKey: ["lecturesDashboard", ...Object.values(params), courseId, lectureId],
            queryFn: () => { }
        });
    }

    return { isPending, lectureStudents };
}